import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsBudget.css';
import Button from 'components/shared/button/Button';
import NewBudgetModal from 'components/admin/work-orders/details/budget/NewBudgetModal';
import {
  loadEmailBudgetDataRequest,
  openApproveReviewModal,
  openModal,
} from 'actions/admin/work-orders/details/budget';
import { getBudget } from 'selectors/admin/work-orders/details/details';
import SimpleTable from 'components/shared/table/SimpleTable';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import BudgetStatus from 'components/shared/text/BudgetStatus';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';
import { BudgetStatusKeys } from 'domain/budget';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';

class DetailsBudget extends Component {
  constructor(props) {
    super(props);
    this.userIsAdmin =
      usersUtil.isAdmin(this.props.currentUser) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    this.userIsClient = usersUtil.hasType(this.props.currentUser, TYPES.CLIENT);
  }

  render() {
    let component = null;
    if (this.props.budget === null) {
      if (this.userIsAdmin) {
        component = (
          <Button
            className="button-orange create-button"
            label="Create Estimate"
            onClick={this.handleCreateBudget}
          />
        );
      } else {
        component = (
          <div className="no-budget-message">
            <span className="body-bold">No preliminary estimate yet</span>
          </div>
        );
      }
    } else {
      component = (
        <SimpleTable
          className={'budget-table' + (this.userIsAdmin ? ' variance' : '')}
          rows={this.mapBudget(this.props.budget)}
          onRowSelected={this.handleBudgetSelection}
        />
      );
    }

    return (
      <div className="details-budget">
        <div className="budget-container">{component}</div>

        <NewBudgetModal />
      </div>
    );
  }

  handleBudgetSelection = () => {
    if (
      this.userIsClient ||
      (this.userIsAdmin &&
        this.props.budget.status === BudgetStatusKeys.APPROVED)
    ) {
      this.props
        .dispatch(
          loadEmailBudgetDataRequest(
            this.props.currentWorkOrder.number,
            this.props.currentWorkOrder.name,
            this.props.currentWorkOrder.building.location,
            this.props.currentWorkOrder.client.id
          )
        )
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(openApproveReviewModal(this.props.budget));
          }
        });
    } else {
      // open budget to be edited
      this.props
        .dispatch(
          loadEmailBudgetDataRequest(
            this.props.currentWorkOrder.number,
            this.props.currentWorkOrder.name,
            this.props.currentWorkOrder.building.location,
            this.props.currentWorkOrder.client.id
          )
        )
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(openModal(this.props.budget));
          }
        });
    }
  };

  handleCreateBudget = () => {
    this.props.dispatch(openModal());
  };

  mapBudget(budget) {
    const row = [
      <span className="body-bold">{`Preliminary Estimate #${budget.version_number}`}</span>,
      <BudgetStatus status={budget.status} />,
      <Date value={budget.updated_at} format="M/D/YYYY" />,
      <span className="body-bold">
        <Number value={budget.cost} format="$0,0" />
      </span>,
    ];
    if (this.userIsAdmin) {
      row.push(`${budget.variance}%`);
    }
    return [row];
  }
}

export default connect((state) => {
  return {
    budget: getBudget(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    currentUser: getCurrentUser(state),
  };
})(DetailsBudget);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/budget/DetailsBudget.js